import { IdentiteService } from '../../../identite/shared/services/identite.service';
import { Component, OnInit, Input } from '@angular/core';
import { EtatIdentite } from '../../../identite/shared/classes/etat-identite';
import { imgCardDrop } from '../../classes/animations';
import { FormControl } from '@angular/forms';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'app-admin-list-etat-identite',
    templateUrl: './admin-list-etat-identite.component.html',
    styleUrls: ['./admin-list-etat-identite.component.css'],
    animations: [imgCardDrop]
})
export class AdminListEtatIdentiteComponent implements OnInit {

    etatsIdentite: EtatIdentite[];
    lstPays: any[];
    newEtatIdentite = new EtatIdentite();
    selected = new FormControl(0);

    aclConfig: AclAccess;

    @Input()
    triggerReload: () => void;

    constructor(
        private identiteService: IdentiteService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.etatsIdentite = [];
    }


    getEtatsIdentite() {
        this.etatsIdentite = [];
        this.identiteService.getEtatIdentite('withAcl')
            .subscribe(retour => {
                if (retour.status === 200) {
                    retour.data.forEach(element => {
                        this.etatsIdentite.push(new EtatIdentite(element));
                    });
                }
            });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getEtatsIdentite();
        }
    }

    insertEtatIdentite(etat: EtatIdentite) {
        this.identiteService.insertEtatIdentite(etat)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.newEtatIdentite = new EtatIdentite();
                    this.alertService.success(TRANSLATE('Etat ajouté avec succès'));
                    if (this.triggerReload) {
                        this.triggerReload();
                    }
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    updateEtatIdentite(etat: EtatIdentite) {
        this.identiteService.updateEtatIdentite(etat.eti_id, etat)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Etat modifié avec succès'));
                    if (this.triggerReload) {
                        this.triggerReload();
                    }
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    deleteEtatIdentite(etat: EtatIdentite) {
        this.identiteService.deleteEtatIdentite(etat.eti_id)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Etat supprimée avec succès'));
                    this.getEtatsIdentite();
                    if (this.triggerReload) {
                        this.triggerReload();
                    }
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }
}
